import { render } from "./privacy.vue?vue&type=template&id=3be7f7ce&scoped=true&bindings={}"
import script from "./privacy.vue?vue&type=script&lang=ts"
export * from "./privacy.vue?vue&type=script&lang=ts"

import "./privacy.vue?vue&type=style&index=0&id=3be7f7ce&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3be7f7ce"

export default script